import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { InquiryHeaderTitle } from '../molecules/InquiryHeaderTitle';
import { InquiryHeaderButton } from '../molecules/InquiryHeaderButton';
import { DivInRight } from '../atoms';
import { useRootStore } from '../../App';

//TODO: almost same style as InquiryListHeader..
const StyledSection = styled.section`
  background: #ffffff;
  border-bottom: solid 1px #e2e2e2;
  text-align: left;
  position: relative;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `color: #333333;
      font-size: 20px;
      line-height: normal;
      margin-bottom: 10px;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-right: 13px;`
      : `border-top: solid 1px #e2e2e2;
      padding: 16px 16px;`}
`;

export const InquiryDetailHeader = observer(() => {
  const root = useRootStore();
  const { isWide } = root.layoutStore;

  return (
    <StyledSection isWide={isWide}>
      <div>
        <InquiryHeaderTitle isWide={isWide}>問い合わせ</InquiryHeaderTitle>
      </div>
      <DivInRight>
        <InquiryHeaderButton
          onClick={() => {
            root.routerStore.push(`/inquiry`);
            root.inquiryStore.fetchInquiryList();
          }}
          showUnreadBadgeSpan={false}
        ></InquiryHeaderButton>
      </DivInRight>
    </StyledSection>
  );
});
